import React, { useState, useEffect } from 'react'
import userService from '../../services/userService'
import ResearchListComponent from '../../components/ResearchListComponent/ResearchListComponent'
import { Research } from '../../services/models'
import { Typography } from 'antd'

type Props = {}

const FeedPage: React.FC<Props> = () => {
  const [items, setItems] = useState<Research[]>([])

  useEffect(() => {
    userService.feed().then((data) => setItems(data.data))
  }, [])

  // Отступы и белая подложка принадлежат PageShell, страница их не дублирует.
  return (
        <>
          <Typography.Title>Лента</Typography.Title>
          <ResearchListComponent items={items}/>
        </>
  )
}

export default FeedPage
